import React from 'react'
import styled from 'styled-components'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useDebounce } from 'hooks'

// Copied from Quill/types
interface QuillProps {
    id?: string;
    className?: string;
    theme?: string;
    style?: React.CSSProperties;
    readOnly?: boolean;
    value?: string | any;
    defaultValue?: string | any;
    placeholder?: string;
    tabIndex?: number;
    bounds?: string | HTMLElement;
    scrollingContainer?: string | HTMLElement;
    onChangeSelection?: (
        range: any,
        source: any,
        editor: any
    ) => void;
    onFocus?: (
        range: any,
        source: any,
        editor: any
    ) => void;
    onBlur?: (
        previousRange: any,
        source: any,
        editor: any
    ) => void;
    onKeyPress?: React.EventHandler<any>;
    onKeyDown?: React.EventHandler<any>;
    onKeyUp?: React.EventHandler<any>;
    formats?: string[];
    children?: React.ReactElement<any>;
    modules?: any;
    preserveWhitespace?: boolean;

    /** @deprecated
     * The `toolbar` prop has been deprecated. Use `modules.toolbar` instead.
     * See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.
     * */
    toolbar?: never;

    /** @deprecated
     * The `styles` prop has been deprecated. Use custom stylesheets instead.
     * See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100
     */
    styles?: never;

    /**
     * @deprecated
     * The `pollInterval` property does not have any effect anymore.
     * You can safely remove it from your props.
     * See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.
     */
    pollInterval?: never;
}

interface HtmlEditorProps extends QuillProps {
    debounceTime?: number
    onChange: ( // make onChange required
        content: string,
        delta: any,
        source: any,
        editor: any
    ) => void;
}

const S = {
    HtmlEditor: styled(ReactQuill)`
        .ql-container {
            font-size: 1rem;
            p {
                margin-bottom: 1rem;
            }
        }
    `
}

const HtmlEditor = ({ debounceTime, ...props }: HtmlEditorProps) => {
    const onChange = useDebounce(props.onChange, debounceTime)
    // @ts-ignore
    return <S.HtmlEditor {...props} onChange={onChange} />
}

export default HtmlEditor
